import { useEffect, useState } from "react";
import type { HomeLayout } from "../../api/hub/home";
import { copyLayout } from "./layout";
export type EditingDraft = {
  layout: HomeLayout;
  baseVersion: number;
  baseLayout: string;
};
export function useHomeEditing() {
  const [draft, setDraft] = useState<EditingDraft | null>(null),
    [navigationBlocked, setNavigationBlocked] = useState(false),
    [mobile, setMobile] = useState(() =>
      window.matchMedia("(max-width:800px)").matches
    );
  useEffect(() => {
    const query = window.matchMedia("(max-width:800px)"),
      change = () => setMobile(query.matches);
    query.addEventListener("change", change);
    return () => query.removeEventListener("change", change);
  }, []);
  useEffect(() => {
    if (!draft) return;
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [!!draft]);
  useEffect(() => {
    if (!draft) return;
    const guard = (event: MouseEvent) => {
      const anchor = (event.target as Element | null)?.closest<
        HTMLAnchorElement
      >("a[href]");
      if (
        !anchor || anchor.target === "_blank" || event.metaKey || event.ctrlKey
      ) return;
      const target = new URL(anchor.href, window.location.origin);
      if (
        target.pathname === window.location.pathname &&
        target.search === window.location.search
      ) return;
      event.preventDefault();
      event.stopPropagation();
      setNavigationBlocked(true);
    };
    document.addEventListener("click", guard, true);
    return () => document.removeEventListener("click", guard, true);
  }, [!!draft]);
  const begin = (layout: HomeLayout, version: number) => {
    setNavigationBlocked(false);
    setDraft({
      layout: copyLayout(layout),
      baseVersion: version,
      baseLayout: JSON.stringify(layout),
    });
  };
  const change = (layout: HomeLayout) =>
    setDraft((current) => current ? { ...current, layout } : current);
  return { draft, setDraft, begin, change, mobile, navigationBlocked };
}
